import { OrgPricingResponse } from '@goldcast/api/backend';

const mutations = {
  setOrgPricingConfig(state, orgPricingConfig: OrgPricingResponse) {
    state.orgPricingConfig = orgPricingConfig;
  }
};

export default mutations;
